/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { CreateActivityEventRequest } from '../models/index';
import {
	CreateActivityEventRequestFromJSON,
	CreateActivityEventRequestToJSON,
} from '../models/index';

export interface PostActivityEventRequest {
	xBffCsrf?: string;
	createActivityEventRequest?: CreateActivityEventRequest;
}

/**
 * EventingApi - interface
 *
 * @export
 * @interface EventingApiInterface
 */
export interface EventingApiInterface {
	/**
	 * This will create an activity event.
	 * @summary Post an activity event.
	 * @param {string} [xBffCsrf]
	 * @param {CreateActivityEventRequest} [createActivityEventRequest] Payload to create an activity event.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof EventingApiInterface
	 */
	postActivityEventRaw(
		requestParameters: PostActivityEventRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * This will create an activity event.
	 * Post an activity event.
	 */
	postActivityEvent(
		requestParameters: PostActivityEventRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;
}

/**
 *
 */
export class EventingApi extends runtime.BaseAPI implements EventingApiInterface {
	/**
	 * This will create an activity event.
	 * Post an activity event.
	 */
	async postActivityEventRaw(
		requestParameters: PostActivityEventRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/eventing/activity`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: CreateActivityEventRequestToJSON(
					requestParameters.createActivityEventRequest
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * This will create an activity event.
	 * Post an activity event.
	 */
	async postActivityEvent(
		requestParameters: PostActivityEventRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.postActivityEventRaw(requestParameters, initOverrides);
	}
}
